import React from "react";
import styled from "styled-components";

const Box = styled.div`
  padding: 10px 0;
`;

const TextBox = styled.div``;
const Text = styled.div`
  padding: 10px 0;
`;

const Header = styled.div`
  position: relative;
  width: 100%;

  &:before {
    position: absolute;
    content: "";
    background-color: var(--sec-color);

    height: 1px;
    right: 0;
    bottom: 0;
  }
`;

const Title = styled.h2`
  font-size: 16px;
  padding-bottom: 10px;
  width: 50%;
  border-bottom: 1px solid var(--sec-color);
  font-weight: normal;
  color: var(--sec-color);
`;

const Fadl = styled.div`
  color: var(--sec-color);
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 10px;
`;

function AzkarListHeader({ List }) {
  return (
    <>
      {List.map((item) => (
        <Box key={item.id}>
          <Header>
            <Title>{item.title}</Title>
          </Header>
          <TextBox>
            {item.text.map((text) => (
              <Text>{text}</Text>
            ))}
            <Fadl>{item.fadl}</Fadl>
          </TextBox>
        </Box>
      ))}
    </>
  );
}

export default AzkarListHeader;
